const themeConfig = {
    theme: 'dark', // light, dark
    menu: 'horizontal', // vertical, collapsible-vertical, horizontal
    layout: 'full', // full, boxed-layout
    animation: 'animate__fadeIn',
    navbar: 'navbar-floating', // navbar-sticky, navbar-floating, navbar-static
    semidark: false,
};

export default themeConfig;
